<template>
  <div id="omise-footer">
    <span class="text--secondary">Secured by </span>
    <img :srcSet="utility.getImgSrcSet('logo_omise', 'png', true)" />
  </div>
</template>

<script>
export default {
  name: 'OmiseFooter'
}
</script>

<style scoped lang="scss">
#omise-footer {
  text-align: center;
  margin: 0 0 16px;
  img {
    vertical-align: middle;
  }
}
</style>
